import { useState } from 'react';
import axios from 'axiosInstance';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import './css/Eventos.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';

function CrearEvento() {
  const navigate = useNavigate();
  const user = JSON.parse(sessionStorage.getItem('user')); 
  const userId = user?.id;

  const [nuevoEvento, setNuevoEvento] = useState({
    nombre: '',
    tipo: '',
    fecha_inicio: '',
    fecha_fin: '',
    estado: ''
  });

  const [error, setError] = useState(null); 

  const manejarCambio = (e) => {
    setNuevoEvento({
      ...nuevoEvento,
      [e.target.name]: e.target.value
    });
  };

  const volver = () => {
    navigate(-1);
  };

  const crearEvento = async (e) => {
    e.preventDefault();

    setError(null); 

    const datosEvento = {
      ...nuevoEvento,
      usuario_creador: userId
    };

    try {
      await axios.post(process.env.REACT_APP_BACKEND_URL + '/api/eventos', datosEvento);

      
      setNuevoEvento({
        nombre: '',
        tipo: '',
        fecha_inicio: '',
        fecha_fin: '',
        estado: ''
      });

      navigate('/eventos');
    } catch (error) {
      const mensaje =
        error.response?.data?.message ||
        error.response?.data ||
        error.message ||
        'Error desconocido al crear el evento';
      setError(mensaje);
      console.error('Error al crear evento:', mensaje);
    }
  };

  return (
    <Container className="contenedorEventos p-4">
      <Button className="boton_accion" size="sm" onClick={volver}>
        ⬅ Volver
      </Button>
      <h2 className="tituloEvento">Crear Evento</h2>
      <Form onSubmit={crearEvento}>
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Nombre del evento</Form.Label>
              <Form.Control
                type="text"
                name="nombre"
                value={nuevoEvento.nombre}
                onChange={manejarCambio}
                required
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Tipo de evento</Form.Label>
              <Form.Select
                name="tipo"
                value={nuevoEvento.tipo}
                onChange={manejarCambio}
                required
              >
                <option value="">Seleccione un tipo</option>
                <option value="1">Colonias</option>
                <option value="2">Actividades</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Fecha de inicio</Form.Label>
              <Form.Control
                type="date"
                name="fecha_inicio"
                value={nuevoEvento.fecha_inicio}
                onChange={manejarCambio}
                required
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Fecha de fin</Form.Label>
              <Form.Control
                type="date"
                name="fecha_fin"
                value={nuevoEvento.fecha_fin}
                onChange={manejarCambio}
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Estado del evento</Form.Label>
              <Form.Select
                name="estado"
                value={nuevoEvento.estado}
                onChange={manejarCambio}
                required
              >
                <option value="">Seleccione un estado</option>
                <option value="1">Abierto</option>
                <option value="2">Cerrado</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        {error && (
          <div style={{ color: 'red', marginBottom: '15px', fontWeight: 'bold' }}>
            {error}
          </div>
        )}

        <Button className="boton_accion mt-5 w-100" type="submit">
          Crear Evento
        </Button>
      </Form>
    </Container>
  );
}

export default CrearEvento;
